module.exports = __webpack_public_path__ + "img/122.3225e8d4.png";